import React from "react";
import "./Reviews.css";
import { getAllReviews } from "../api";
import { NavLink, Link } from "react-router-dom";

/* loggedInUser */
class Reviews extends React.Component {
  state = {
    reviews: [],
  };

  async componentDidMount() {
    const response = await getAllReviews();
    this.setState({
      reviews: response.data,
    });
  }

  render() {
    return (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/profile">
            <img src="/images/back.png" />
          </NavLink>

          <h1>Your Reviews</h1>
        </div>

        <div className="totalReviews">
          {this.state.reviews.map((review, index) => {
            return (
              <Link
                style={{ textDecoration: "none", color: "black" }}
                to={{
                  pathname: "/profile/reviews/id",
                  place: {
                    name: review.name,
                    icon: review.icon,
                    date: review.date,
                    hour: review.hour,
                    titleReview: review.titleReview,
                    posReview: review.posReview,
                    negReview: review.negReview,
                    userRating: review.userRating,
                  },
                }}
              >
                <section key={index} className="reviewBox">
                  <div className="reviewInfoBox">
                  <p className="reviewPostBox">Review Posted</p>
                    <h2>{review.name}</h2>
                    <p>{review.icon}</p>
                    <div className="reviewDateBox">
                      <p>{new Date(review.date).toDateString()}</p>
                      <p className="reviewHourBox">{review.hour}</p>
                    </div>
                  </div>

                  <div className="reviewRatingBox">
                    <h3>{review.userRating}</h3>
                    <h4>{review.titleReview}</h4>
                  </div>
                </section>
              </Link>
            );
          })}
        </div>
      </main>
    );
  }
}

export default Reviews;
